<template>
    <div>
        <v-container fluid class="px-0 search-doctor-banner pb-0" style="min-height: 150px">
            <v-container fluid class="pb-0" :class="{'pl-12': $vuetify.breakpoint.mdAndUp}">
                
            </v-container>
        </v-container>
        <v-container v-if="!isLoading">
            <v-dialog v-model="openTicketDialog" persistent max-width="600" >
                <open-ticket :key="openTicketDialog+'ticket'" @closeDialog="callCloseTicketDialog" :appointmentId="appointment.id"></open-ticket>
            </v-dialog>
            <v-row>                                
                                                                
                <v-col cols="12" sm="12" md="8" class="mb-6 mt-8">
                    <v-row class="text-center">
                        <v-col cols="12" class="">
                            <v-row>
                                <v-col cols="12">

                                    <svg v-if="apptStatus=='success'" width="224" height="182" viewBox="0 0 308 266" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M258 133C258 202.036 202.036 258 133 258C63.9644 258 8 202.036 8 133C8 63.9644 63.9644 8 133 8C202.036 8 228 55.5 228 55.5"
                                              stroke="#1B222E" stroke-opacity="0.75" stroke-width="15"/>
                                        <path d="M62 130.024L117.116 191L300 45" stroke="#1B222E" stroke-opacity="0.75"
                                              stroke-width="15" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <svg v-if="apptStatus=='retry'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#1B222E" fill-opacity="0.75" width="224" height="224">
                                        <path  d="M0 0h24v24H0V0z" fill="none"/>
                                        <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
                                    </svg>
                                    <svg v-if="apptStatus=='released'" xmlns="http://www.w3.org/2000/svg" height="224" viewBox="0 0 24 24" width="224"><path d="M0 0h24v24H0z" fill="none"/><path fill="#1B222E" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"/></svg>
                                    
                                    <h1>{{ title }}</h1>

                                    <div class="my-1 grey--text text--darken-1">
                                        {{ subtitle }}
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12 my-0">
                            <v-btn text class="accent white--text mr-4" @click="goToPatientPortalMain('')" v-if="apptStatus=='success'">
                                Explore Dashboard
                            </v-btn>
                            <v-btn text class="accent white--text mr-4" @click="payNow()" v-if="apptStatus=='retry'">
                                Retry Payment
                            </v-btn>

                            <!-- <v-btn text class="green white--text" @click="payNow">
                                <v-icon left>mdi-shield</v-icon>
                                Pay Now
                            </v-btn> -->
                        </v-col>

                        <v-col cols="12 my-0" v-if="apptStatus=='retry' || apptStatus=='released'" class="mt-8">
                                <div class="my-1 grey--text text--darken-1">
                                    Facing any issues? Do you want to raise a ticket?
                                </div>
                            
                            <v-btn text class="accent white--text mr-4 mt-3" @click="openTicketDialog = true">
                                Raise Ticket
                            </v-btn>                            
                        </v-col>
                    </v-row>
                    
                </v-col>
                
                <v-col cols="12" sm="12" md="4" class="hidden-sm-and-down mt-12" v-if="appointment">
                    
                    <doctor-card
                        :appointment="appointment" 
                        :clinic="appointment.clinic"
                        :doctor="appointment.doctor" 
                        :appointment_type="appointment.type" 
                        :fee="appointment.fee_amount"
                        :show_map_btn="true"                        
                        :start_time="appointment.start_time"
                        :end_time="appointment.end_time"
                        :date="appointment.start_time"
                    >
                    </doctor-card>
                    
                </v-col>
            </v-row>

        </v-container>                

        <!--        Mobile HTML Below -->
        <v-btn
                fixed
                fab
                color="accent"
                left
                bottom
                class="hidden-md-and-up ml-1"
                @click="doctorDialog = true"
        >
            <v-icon>mdi-doctor</v-icon>
        </v-btn>

        <!--        Doctor Modal-->
        <v-dialog v-model="doctorDialog" max-width="900" v-if="appointment">
            <v-card flat class="white pt-10">
                <v-card-text class="pt-4">
                    <doctor-card
                    
                        :appointment="appointment" 
                        :clinic="appointment.clinic"
                        :doctor="appointment.doctor" 
                        :appointment_type="appointment.type" 
                        :fee="appointment.fee_amount"
                        :show_map_btn="true"
                        :start_time="appointment.start_time"
                        :end_time="appointment.end_time"
                    >
                    </doctor-card>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn text @click.prevent="doctorDialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';    
    import DoctorCard from "../components/Doctor/DoctorCard";
    import OpenTicket from "../components/OpenTicket";

    export default {
        name: "AppointmentCreated",
        components:{
            DoctorCard,
            OpenTicket
        },
        watch: {
            bookingDate(bookingDate) {
                this.getSchedule(bookingDate)
            },
        },        
        computed: {
            ...mapGetters([
                'accessToken',
                'userInfo'
            ]),
        },
        mounted() {                        
            this.getAppointment();
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken')                                    
                        
        },
        data() {
            return {
                isSlotReleased:false,
                apiUrl:process.env.VUE_APP_API_URL,
                doctorDialog: false,
                isLoading: false,                                
                apptStatus:'',
                title:"Your Appointment has been scheduled",
                subtitle:"Complete your profile and keep track of all your questions, book appointments & save medical records.",
                appointment:{
                    doctor:null,
                    clinic:null,
                },
                openTicketDialog: false,
            }
        },
        methods: {            
            callCloseTicketDialog(value) {
                this.openTicketDialog = false
                if(value)
                this.showTicketSnackbar = true
            },
            setSuccessUi(){
                this.title = "Your Appointment has been scheduled";
                this.subtitle = "Complete your profile and keep track of all your questions, book appointments & save medical records.";
                this.apptStatus = 'success'
            },
            setRetryUi(){
                this.title = "Payment failed";
                this.subtitle = "Complete payment to book your appointment";
                this.apptStatus = 'retry'
            },
            setSlotReleasedUi(){
                this.title = "Slot Released";
                this.subtitle = "Your appointment slot has been released. Please book another appointment";
                this.apptStatus = 'released'
            },
            payNow() {
                let data = {
                    appointment_id: this.appointment.id                    
                }
                                
                let payload = btoa(JSON.stringify(data));

                let url = process.env.VUE_APP_API_URL + '/payments/initiate?payload=' + payload;
                window.location.href = url;
            },
            getAppointment() {
                this.isLoading = true
                this.axios
                    .get(`${process.env.VUE_APP_API_URL}/api/appointments/` + this.$route.params.id)
                    .then((response) => {    
                        
                        this.appointment = response.data.data;                        
                        if(this.appointment.deleted_at){
                            
                            this.isSlotReleased = true
                            this.setSlotReleasedUi()
                        }                            
                        else{
                            if(this.appointment.online_unpaid_bill){
                                this.setRetryUi()
                            }
                            else{
                                this.setSuccessUi()
                            }
                        }                        
                                        
                    }).catch((error) => {
                        console.log(error);
                    }).finally(() => {
                        this.isLoading = false;
                    })
            },        
            openMap(clinic){
                var link ='https://www.google.com/maps/search/?api=1&query=' + clinic.latitude + ',' + clinic.longitude
                window.open(link);                
            }
        },
    }
</script>

<style scoped>
    .time-slots .v-chip {
        background-color: #fafafa;
    }
</style>
